import { hasPayloadProgress } from '~/utils/societePayloadBuilder/hasProgress';

import { createDefaultPromoCardCarouselState } from './defaults';
import type { LuxPlusPromoCardCarouselState } from './types';

function snapshotPromoCardCarouselState(state: LuxPlusPromoCardCarouselState): string {
  return JSON.stringify({
    promos: state.promos.map((promo) => ({
      type: promo.type,
      label: promo.label.trim(),
      title: promo.title.trim(),
      subtitle: promo.subtitle.trim(),
      expiresAt: promo.expiresAt.trim(),
      eligibleRegions: [...promo.eligibleRegions].sort(),
      promoCode: promo.promoCode.trim(),
      termsAndConditions: promo.termsAndConditions.trim(),
      primaryActionText: promo.primaryActionText.trim(),
      primaryActionHref: promo.primaryActionHref.trim(),
      ctaText: promo.ctaText.trim(),
      ctaLink: promo.ctaLink.trim(),
    })),
  });
}

export function hasPromoCardCarouselProgress(state: LuxPlusPromoCardCarouselState, loadJson: string): boolean {
  return hasPayloadProgress(state, loadJson, createDefaultPromoCardCarouselState, snapshotPromoCardCarouselState);
}
